import type { MaturityItemId } from '@cobliteam/hooks/src/useBasicValueMaturity/basicValueMaturityModel';
import type { MaturityItemState } from '@cobliteam/hooks/src/useBasicValueMaturity/useBasicValueMaturity';
import type { ComponentType } from 'react';
import DeviceAssociationForm from './forms/DeviceAssociationForm';
import DriverAssociationForm from './forms/DriverAssociationForm';
import DriversForm from './forms/DriversForm';
import GroupsForm from './forms/GroupsForm';
import SpeedForm from './forms/SpeedForm';
import UsersForm from './forms/UsersForm';
import VehiclesForm from './forms/VehiclesForm';

/** The Setup Guide items resolved by a dedicated creation modal (card → form → success). */
export type SetupGuideEntityId = 'users' | 'drivers' | 'vehicles' | 'device-association' | 'driver-association' | 'groups' | 'speed';

export interface SetupGuideEntityFormProps {
  fleetId?: string;
  /** Maturity state of the item — current/target feed the progress Tag; route feeds the shortcut. */
  item: MaturityItemState;
  /** Closes the whole guide (X, Esc, Cancelar). */
  onClose: () => void;
  /** Mutation succeeded — the orchestrator swaps to the success modal. */
  onSuccess: (createdCount: number) => void;
  /** "Configurações avançadas": closes the guide and navigates to the entity's full page. */
  onAdvancedSettings: () => void;
}

/** Registry of the entity creation forms (AE-2443), one per Setup Guide entity id. */
export const SETUP_GUIDE_ENTITY_FORMS: Record<SetupGuideEntityId, ComponentType<SetupGuideEntityFormProps>> = {
  'device-association': DeviceAssociationForm,
  'driver-association': DriverAssociationForm,
  drivers: DriversForm,
  groups: GroupsForm,
  speed: SpeedForm,
  users: UsersForm,
  vehicles: VehiclesForm,
};

export const isSetupGuideEntityId = (id: MaturityItemId | null): id is SetupGuideEntityId => id !== null && id in SETUP_GUIDE_ENTITY_FORMS;
